const openDataURL = process.env.VUE_APP_OpenData_Base_Resource_URL;
const openDataToken = process.env.VUE_APP_OpenData_APP_TOKEN;
const miEconomyApi = process.env.VUE_APP_API_URL;

export async function GetSpotlight() {
    const url = `${miEconomyApi}Metrics/Featured`;
    console.log(url)
    try {
        const resp = await fetch(url,{method:"GET"});
        if (resp.status == 200) {
            return await resp.json();
        } else {
            if (resp.status == 400) {
                console.log("400 response - Bad token!");
            } else {
                console.log(`${resp.status} response - Unknown`)
            }

            alert("Error fetching spotlight");
            return [];
        }        
    } catch (error) {
        console.log(error);
    }

}

export async function GetMetricData(code:string){
    const url = `${openDataURL}${code}.json`;
    const resp =  await fetch(url,{
        method:'GET',
        headers: {
            'X-App-Token': openDataToken
        }
    });

    if (resp.status == 200) {
        return await resp.json();
    } else {
        if (resp.status == 400) {
            console.log("400 response - Bad token!");
        } else {
            console.log(`${resp.status} response - Unknown`)
        }

        alert("Error fetching metric");
        return [];
    }
}

export async function GetEsriMetricData(endpoint: string) {
    const resp =  await fetch(`${endpoint}/query`, {
        method: 'POST',
        headers: {
            'content-type': 'application/x-www-form-urlencoded'
        },
        body: `where=${encodeURIComponent('1=1')}&outFields=${encodeURIComponent("*")}&f=json`
    });

    if (resp.status == 200) {
        return transformEsriDataToOldFormat(await resp.json());
    } else {
        console.log(`${resp.status} response - Unknown`);

        alert("Error fetching metric");
        return [];
    }
}

interface EsriResponse {
    fields: Array<{
        name: string;
        type: string;
        alias: string;
        sqlType: string;
        domain: string | null;
        defaultValue: string | null;
    }>,
    features: Array<{attributes: Record<string, any>}>;
}

// If we could use the alias field in the Esri fields response
// to control the mapping, this would be easier. Alternatively
// we could avoid the mapping altogether, but that touches more
// stuff so ehhh
function transformEsriDataToOldFormat(data: EsriResponse): Record<string, any> {
    const transformedData = data.features.map(feature => {
        const newObj: Record<string, any> = {};
        for (const key of Object.keys(feature.attributes)) {
            let sanitizedKey = key.toLowerCase();

            // This is primarily for the month_ field used on labor force by state
            // but could apply to other fields as we implement more esri data
            if (sanitizedKey.endsWith("_")){
                sanitizedKey = sanitizedKey.substring(0, sanitizedKey.length-1);
            }
            newObj[sanitizedKey] = feature.attributes[key]?.toString();
        }
        return newObj;
    });

    return transformedData;
}
